import React, { useMemo } from 'react';
import { useDiscoveryQuery } from './queries';
import { insertValueIfDefined, Loading } from '@mss/mss-component-library';
import { useLocation } from 'react-router-dom';
import Import, { emptyConnectionTest } from '../Import';

export function Add() {
  const allDiscoveryAssets = useDiscoveryQuery();
  const location = useLocation();
  const ids = useMemo(
    () => new URLSearchParams(location.search).get('ids')?.split(',') ?? [],
    [location.search]
  );

  const discoveryAssets = useMemo(
    () =>
      allDiscoveryAssets.data
        ? ids.reduce((acc, id) => {
            const asset = allDiscoveryAssets.data?.find(
              x => String(x.id) === String(id)
            );

            return [
              ...acc,
              ...insertValueIfDefined({ ...asset, tempId: acc.length }),
            ];
          }, [] as any[])
        : [],
    [ids, allDiscoveryAssets.data]
  );

  if (allDiscoveryAssets.isLoading || !discoveryAssets.length) {
    return <Loading />;
  }

  return (
    <Import
      disableImportSteps
      values={{
        assets: discoveryAssets.map(a => ({
          values: a,
          test_direct: emptyConnectionTest(),
          test_ssh: emptyConnectionTest(),
          test_telnet: emptyConnectionTest(),
          test_snmp: emptyConnectionTest(),
        })),
      }}
    />
  );
}
